import type { SharedValue } from 'react-native-reanimated'

export const assignAnimatedValue = <T>(sharedValue: SharedValue<T>, value: T) => sharedValue.set(value)
